import type { GetStaticPaths } from 'next';
import WellSectionHub, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => ({
  fallback: 'blocking',
  paths: [],
});

export default WellSectionHub;
